import { HTTPError } from 'ky';

// The backend refuses node commands and resizes with a reason in `detail` (a drain
// hold, a version gate, the node's slot budget); that sentence is what the operator
// needs to read, so every dialog surfaces it instead of a generic failure line.
// ky has already consumed the body into `error.data` by the time the error reaches
// us, so the response body is only a fallback for an error built by hand.
export async function errorMessage(error: unknown): Promise<string> {
  if (error instanceof HTTPError) {
    const detail = detailOf(error.data);
    if (detail) return detail;
    try {
      const fromBody = detailOf(await error.response.json());
      if (fromBody) return fromBody;
    } catch {
      /* fall through */
    }
    return `${error.response.status} ${error.response.statusText}`;
  }
  return error instanceof Error ? error.message : String(error);
}

function detailOf(data: unknown): string | undefined {
  if (data && typeof data === 'object' && 'detail' in data && typeof data.detail === 'string') return data.detail;
  return undefined;
}
